import React from "react";
import "./Web.css";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import img12 from "../assets/12.png";
import { FaArrowCircleDown } from "react-icons/fa";

const steps = [
    {
        title: "Create an Account",
        description: "Sign up for a trading account if you haven’t already. Registration is quick and easy. Just contact us today. Our Support agents will help you to navigate and guide you to open an account."
    },
    {
        title: "Download the Terminal",
        description: "Ask our support agent to get the latest version of the Globus Trading PC Terminal or login to client cabinet after signup and you will have option of downloading the PC terminal."
    },
    {
        title: "Log In",
        description: "Use your credentials to log into the terminal and start exploring its features. When you signup with Globus trading, you will get the login credentials for client cabinet and also your trading account will be opened and you can login with your trading account and password to your PC terminal and start trading."
    },
    {
        title: "Fund Your Account",
        description: "Deposit funds to begin trading. We offer multiple funding options for your convenience. After login to your cabinet you will have the option to deposit funds in your trading account. We provide many payment options to fund your trading account. After adding the funds you can start the trading with Globus trading."
    }
];


const features = [
    {
        title: "User-Friendly Interface",
        description: "Our platform features a sleek, user-friendly design that ensures a smooth and efficient trading experience. Easily navigate through different sections, execute trades with a single click, and customize your dashboard to suit your trading style."
    },
    {
        title: "Advanced Charting Tools",
        description: "Analyze the markets like a pro with our advanced charting tools. Access a wide range of indicators, drawing tools, and customizable charts to help you make informed trading decisions. Whether you prefer candlestick, bar, or line charts, Globus Web Trader has you covered."
    },
    {
        title: "Real-Time Market Data",
        description: "Stay ahead of the curve with real-time quotes and market data. Globus Web Trader provides up-to-the-minute information on currency pairs, indices, commodities, and more, ensuring you’re always in the know."
    },
    {
        title: "Secure and Reliable",
        description: "Your security is our priority. Globus Web Trader employs the latest encryption technology to protect your data and transactions. Trade with confidence knowing your information is safe and secure on our platform."
    },
    {
        title: "Access Anywhere, Anytime",
        description: "Globus Web Trader is accessible from any device with an internet connection, without the need for downloads or installations. Trade on-the-go with full functionality from your desktop, laptop, tablet, or smartphone."
    },
    {
        title: "Powerful Trading Tools",
        description: "Leverage our suite of powerful trading tools including automated trading, stop loss, take profit, and trailing stops to optimize your trading strategy. Globus Web Trader offers everything you need to enhance your trading performance."
    }
];

const Web = () => {
    return (
        <>
            <Navbar />

            {/* About Us Section */}
            <div className="pc-section">
                <h2 className="pc-title">Globus Web Trader</h2>
            </div>

            {/* Section 1: Two Columns - Image Left, Details Right */}
            <div className="pc-container">
                <div className="pc-content">
                    <div className="pc-image">
                        <img src={img12} alt="Globus PC Terminal" />
                    </div>
                    <div className="pc-details">
                        <h2>Globus Web Trader</h2>
                        <p>
                        At Globus Trading, we empower traders with an intuitive and powerful online trading platform designed to meet the needs of both novice and seasoned traders. Globus Web Trader offers state-of-the-art technology, comprehensive tools, and a seamless trading experience, all from the convenience of your web browser.
                        </p>
                    </div>
                </div>
            </div>

            {/* Key Features Section */}
            <div className="features-section">
                <h2 className="features-title">Why Choose Globus Web Trader?</h2>
                <div className="features-grid">
                    {features.map((feature, index) => (
                        <div className="feature-box" key={index}>
                            <h3>{feature.title}</h3>
                            <p>{feature.description}</p>
                        </div>
                    ))}
                </div>
            </div>

        

            <div className="get-started-section4">
                <h2>How to Get Started</h2>
                <p>Follow below steps to get started with out Globus Web trader. You will get access to our Web trader instantly.</p>

                <div className="steps-container">
                    <div className="step-box">
                        <div className="icon">⬇️</div>
                        <h3>Create an Account</h3>
                        <p>Sign up for a trading account if you haven’t already. Registration is quick and easy. Just contact us today. Our Support agents will help you to navigate and guide you to open account.</p>
                    </div>

                    <div className="step-box">
                        <div className="icon">⬇️</div>
                        <h3>Download the Terminal</h3>
                        <p>Ask our support agent to get the latest version of the Globus Trading PC Terminal or login to client cabinet after signup and you will have option of downloading the Pc terminal.</p>
                    </div>

                    <div className="step-box">
                        <div className="icon">⬇️</div>
                        <h3>Log In</h3>
                        <p>Use your credentials to log into the terminal and start exploring its features. When you signup with Globus trading, you will get the login credentials for client cabinet and also your trading account will be opened and you can login with your trading account and password to your pc terminal and start trading.</p>
                    </div>

                    <div className="step-box">
                        <div className="icon">⬇️</div>
                        <h3>Fund Your Account</h3>
                        <p>Deposit funds to begin trading. We offer multiple funding options for your convenience. After login to your cabinet you will have the option to deposit funds in your trading account. We provide many payment options to fund your trading account. After adding the funds you can start the trading with Globus trading.</p>
                    </div>
                </div>

                <h4 >Enhanced Trading Experience With Globus Trading</h4>
                <p>At Globus Trading, we believe that a successful trading experience is rooted in a platform that combines technology, simplicity, and comprehensive support. Our Web Trader platform is designed to enhance your trading journey with unique features that cater to every aspect of the trading lifecycle.</p>
                <a className="btn primary" href="https://globustrading.co/contact-us/">
                Contact Us Today  ➜
                        </a>
            </div>



            <Footer />
        </>
    );
};

export default Web;
